export enum RegistrationType {
  SIMPLE = 'SIMPLE',
  WITH_ACCOMODATION = 'WITH_ACCOMODATION',
  GROUP = 'GROUP',
}
